import { usePrintCurrencyString } from '@/utils/price';
import { FinanceModel, PeripheralFinanceModel } from '../api/contracts/financemodels';
import { useCatalogueService } from './useCatalogueService';
import { RoleType } from '../authentication/hooks/user';

export const useCataloguePCMPrice = (
  price: number,
  regionCode?: string,
  model?: FinanceModel | PeripheralFinanceModel
) => {
  const [configuration] = useCatalogueService(state => [state.configuration]);
  const printCurrencyString = usePrintCurrencyString({
    regionCode,
    forceSpecifyRegion: configuration.as === RoleType.Admin
  });
  const calculatedPrice = printCurrencyString(price * (model?.pcmFactor || 0));

  if (model) {
    return calculatedPrice;
  } else {
    return undefined;
  }
};
